import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzVday70 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_VDAY_70: Record<
  Exclude<PageIdWoofzVday70, PageIdWoofzVday70.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_VDAY_70]: {
    id: PageId.SUBSCRIPTIONS_VDAY_70,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_VDAY_70]: {
    id: PageId.CHAT_UPSELL_VDAY_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_VDAY_70]: {
    id: PageId.UPSELL_VDAY_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_VDAY_70]: {
    id: PageId.DOWNLOAD_VDAY_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
